import Box from "ds/components/Box";

import ApiKeyExpiresAt from "../../../ApiKey/components/ExpiresAt";
import { CellComponentProps } from "../types";

type ApiKeysListItemExpiresAtCellProps = CellComponentProps;

const ApiKeysListItemExpiresAtCell = ({ apiKey }: ApiKeysListItemExpiresAtCellProps) => {
  return (
    <Box fullWidth gap="large">
      <ApiKeyExpiresAt expiresAt={apiKey.expiresAt} />
    </Box>
  );
};

export default ApiKeysListItemExpiresAtCell;
